<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "Stock",
};
</script>


// WEBPACK FOOTER //
// src/pages/ERP/Warehouse/index.vue